import { BytesStringToKb } from './bytes-string-to-kb';

export interface internalPermissions {
  galleryLimit: number;
  maxTenantSeats: number;
  storage: {
    active: {
      total: number;
      plan: number;
      addOn: number;
    };
  };
  permissions: {
    gallery: {
      password: boolean;
      clientAdvancedMode: boolean;
      embedSection: boolean;
      embedGallery: boolean;
      subGallery: boolean;
      customPresets: boolean;
      forceIdentification: boolean;
    };
    core: {
      storageAddons: boolean;
    };
    asset: {
      favourites: boolean;
      comments: boolean;
      upload: boolean;
      download: boolean;
      status: boolean;
      colorLabels: boolean;
      customLabels: boolean;
      downloadOriginal: boolean;
      approvalLimit: boolean;
      annotations: boolean;
      uploadRaw: boolean;
      watermarking: boolean;
      fileAttachment: boolean;
      assetVersions: boolean;
      video: boolean; // not implemented on backend
      videoInCover: boolean; // not implemented on backend
      customVideoPoster: boolean; // not implemented on backend
    };
    tenant: {
      removePicflowBranding: boolean;
      logoUpload: boolean;
      customDomain: boolean;
      customFonts: boolean;
      members: boolean;
    };
    groups: {
      list: boolean;
    };
  };
}

export const convertPermissions = (
  maxTenantSeats: number,
  scopes: string[],
  permissions: {
    storage_total_limit: number | string;
    storage_plan_limit: number | string;
    storage_addon_limit: number | string;
  }
): internalPermissions => {
  return {
    galleryLimit: -1,
    maxTenantSeats,
    storage: {
      active: {
        total: BytesStringToKb(<string>permissions.storage_total_limit),
        plan: BytesStringToKb(<string>permissions.storage_plan_limit),
        addOn: BytesStringToKb(<string>permissions.storage_addon_limit),
      },
    },
    permissions: {
      gallery: {
        password: scopes.includes('gallery:password'),
        clientAdvancedMode: scopes.includes('gallery:client-advanced-mode'),
        embedSection: scopes.includes('gallery:embed-section'),
        embedGallery: scopes.includes('gallery:embed-gallery'),
        subGallery: scopes.includes('gallery:sub-gallery'),
        customPresets: scopes.includes('gallery:custom-presets'),
        forceIdentification: scopes.includes('gallery:force-identification'),
      },
      core: {
        storageAddons: scopes.includes('core:storage-addons'),
      },
      asset: {
        favourites: scopes.includes('asset:favourites'),
        comments: scopes.includes('asset:comments'),
        upload: scopes.includes('asset:upload'),
        download: scopes.includes('asset:download'),
        status: scopes.includes('asset:status'),
        colorLabels: scopes.includes('asset:color-labels'),
        customLabels: scopes.includes('asset:custom-labels'),
        downloadOriginal: scopes.includes('asset:download-original'),
        approvalLimit: scopes.includes('gallery:approval-limit'),
        annotations: scopes.includes('asset:annotations'),
        uploadRaw: scopes.includes('asset:upload-raw'),
        watermarking: scopes.includes('asset:watermarking'),
        fileAttachment: scopes.includes('asset:file-attachment'),
        assetVersions: scopes.includes('asset-version:multiple'),
        video: scopes.includes('gallery:embed-gallery'), // not implemented on backend, so we use embed-gallery to force plus and up
        customVideoPoster: scopes.includes('asset:custom-labels'), // not implemented on backend, so we use custom-labels to force pro and up
        videoInCover: scopes.includes('asset:custom-labels'), // not implemented on backend, so we use custom-labels to force pro and up
      },
      tenant: {
        removePicflowBranding: scopes.includes('gallery:remove-picflow-branding'),
        logoUpload: scopes.includes('tenant:logo-upload'),
        customDomain: scopes.includes('tenant:custom-domain'),
        customFonts: scopes.includes('tenant:custom-fonts'),
        members: scopes.includes('tenant:members'),
      },
      groups: {
        list: scopes.includes('groups:list'),
      },
    },
  };
};
